import { render, staticRenderFns } from "./viewdisplayitem-component.vue?vue&type=template&id=08d97c1a"
import script from "./viewdisplayitem-component.vue?vue&type=script&lang=ts"
export * from "./viewdisplayitem-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports